/**
 * Normalizes strings by trimming and replacing spaces with a custom separator.
 * @param input - The string to process.
 * @param separator - Character to replace spaces with (default: '-').
 * @returns The processed string.
 */

export const normalizeString = (
    input: string,
    separator: string = '-'
): string => {
    if (!input.trim()) return '';
    return input.toLowerCase().trim().replace(/\s+/g, separator);
};
